import { ApiRequestModel } from "../api_request_model";
import { BaseClass } from "../master/mastermodel";

export class ChangePasswordRequest extends BaseClass {
  public UserName: string;
  public OldPassword: String;
  public NewPassword: string;
  public NewPassword2: string;
  public NewPassword3: string; 
  public NewPassword1: string;
  public ReEnterPassword: string;
  public IsEncriptFromClient: boolean;
  //public SendApiRequestModel: ApiRequestModel;
}
